<script lang="ts">
    import { Button, Icon, Input, InputGroup, FormGroup, Label, Table, Dropdown, DropdownMenu, DropdownItem, DropdownToggle, Popover } from "sveltestrap";
    import type { Diligence } from '../Model/Diligence';
    import { diligencesService, paramsService } from '../services';
    import { Link, navigate } from "svelte-navigator";
    import AppWraper from "../components/AppWraper.svelte";
    import ParamName from '../components/ParamName.svelte';
    import type { Param } from '../Model/Param';
    import { dateInputFormatter, dateTimeInputFormatter } from '../services/Functions';
    import FilterDiligence from "../components/FilterDiligence.svelte";

    export const editDiligence = null;

    let diligences: Diligence[];
    let types: Param[] = [];
    
    let offset = 0;
    let limit = 25;
    let searchFilter = {
        diligence : null,
        select : null,
        date : null
    };
    let date = new Date();
    let endDate = null;
    let startDate = null;
    
    load()
    loadInputDate()

    async function load(searchFilter = null){

        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        diligences = await diligencesService.findDiligences(opts);

        types = await paramsService.findByType('diligencesTypes');

        diligences.sort((a,b) => {
        return a.diligenceNumber < b.diligenceNumber ? -1 : 1;
         })

    } 

    function diligenceUpdate(diligence: Diligence): void {
        let diligenceAct = diligences.find(u => u.id == diligence.id)

        
        if (diligenceAct) {
            diligenceAct = diligence;
            diligences = diligences;
        }
    }

    async function showmoreDiligences(): Promise<void> {
        offset = offset + limit;

        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        const diligencesMore = await diligencesService.findDiligences(opts);

        diligencesMore.sort((a,b) => {
            return a.diligenceNumber < b.diligenceNumber ? -1 : 1;
        })

        diligencesMore.forEach(d => {
            diligences.push(d);
        })
        
        diligences = diligences;
    }

    function newDiligence(){
        navigate('/diligencias/new');
	}

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];

        searchFilter.date = selectedDates;

        load(JSON.stringify(searchFilter));
    }

</script>

<style>

</style>

<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Listado de Diligencias</h3>
                    </div>
                  </div>
                <div class="col-6 col-sm-3 mb-3">
                    <div class="text-end">
                        <Button color="primary" on:click={() => newDiligence()}>
                            Nueva Diligencia
                        </Button>
                    </div>
                </div>
                <div class='col-12'>
                    <FilterDiligence bind:searchFilterComponent={searchFilter} on:load={() => load(JSON.stringify(searchFilter))}/>
                </div>
                <div class="col-12 table-responsive">
                    {#if diligences?.length}
                    <table class="table">
                        <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Nº Diligencia</th>
                                    <th scope="col">Tipo</th>
                                    <th scope='col'>Fecha</th>
                                </tr>
                    
                        </thead>
                        <tbody>
                            {#each diligences as diligence, index }
                                <tr>
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        <Link to="/diligencias/{diligence.id}">
                                            {diligence.diligenceNumber}
                                        </Link>
                                    </td>
                                    <td>
                                        <ParamName id={diligence.diligenceTypeId} />
                                    </td>
                                    <td>
                                        <span class="pe-2">{dateInputFormatter(diligence.entryDate)}</span>
                                        {dateTimeInputFormatter(diligence.entryDate)}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                    <div class="col-12 text-center">
                        <button class="btn btn-primary btn-sm" type="button" on:click={() => showmoreDiligences()} >Ver más</button>
                    </div>
                {:else}
                    <div class="text-center pt-5">
                        <hr>
                        <h3>No hay Diligencias para mostrar</h3>
                    </div>
                {/if}
                </div>
            </div>
        </div>
    </div>

</AppWraper>
